import TimeInput from './TimeInput'
import FormError from './FormError'
import Availability from './Availability'
import axios from 'axios'

export default {
	name: 'OrderRequest',
	props: {
		mamanId: {
			type: Number,
			required: true
		},
		appUrl: {
			type: String,
			required: true
		},
		postToken: {
			type: String,
			required: true
		},
		works: {
			type: Array
		}
	},
	data () {
		return {
			value: {
				date: '',
				e_time_from: '',
				e_time_to: '',
				works: [],
				request: ''
			},
			error: {
				userNotExist: null,
				warning: null,
				fatal: null,
				date: null,
				e_time_from: null,
				e_time_to: null,
				works: null,
				request: null
			},
			loading: false,
			/** @type {boolean} ママンのスケジュールには登録されていないが依頼可能。
			 * 日時を選択したときに予定を調べほかに依頼がない場合は true に設定する */
			possibleRequest: false,
			loadCancel: null
		}
	},
	computed: {
		/**
		 * 開始時刻と終了時刻のどちらかが未入力
		 * @return {boolean}
		 */
		timeIsEmpty () {
			const v = this.value
			return !v.e_time_from || !v.e_time_to
		},
		/**
		 * 入力した時間帯が2時間以上ある場合は true
		 * @return {boolean}
		 */
		timeIsValid () {
			if (this.timeIsEmpty) return false
			const v = this.value
			const ser = (val) => parseFloat(String(val).replace(/:/, '.'))
			return (ser(v.e_time_to) - ser(v.e_time_from) >= 2.0)
		}
	},
	methods: {
		setDate (date) {
			this.value.date = (date == null ? '' : date)
		},
		confirmSubmit () {
			let canSubmit = true

			if (!this.value.date) {
				this.error.date = 'カレンダーで日付を選択してください'
				canSubmit = false
			}
			if (this.timeIsEmpty) {
				this.error.e_time_to = '時間帯を選択してください'
				canSubmit = false
			}
			if (this.value.works.length < 1) {
				this.error.works = '内容を選択してください'
				canSubmit = false
			}

			if (!canSubmit) {
				return
			}

			if (window.confirm('この内容で依頼してもよろしいですか？')) {
				this.submit()
			}
		},
		submit () {
			if (this.loading) {
				return
			}
			this.loading = true
			this.resetErrors()

			const url = `${this.appUrl}/maman/${this.mamanId}/request.json`
			axios.post(url, this.buildPostData(), {})
				.then(response => {
					this.loading = false
					const orderId = response.data.order_id
					// 依頼完了時は依頼詳細へ遷移
					window.location.href = `${this.appUrl}/user/order/${orderId}/`
				})
				.catch(error => {
					this.loading = false
					if (!error.response || !error.response.data) {
						return
					}
					const { data } = error.response

					switch (data.error) {
						case 'userNotExist':
							this.error.userNotExist = true
							break
						case 'validationError':
							this.error.fatal = '入力内容をご確認ください。'
							break
						case 'mamanNotExist':
							this.error.warning = 'ママンの登録が解除されたため依頼できませんでした。別のママンをお探しください。'
							break
						case 'io':
						case 'unknown':
						case 'invalidPost':
						case 'invalidInput':
							this.error.fatal = 'システムでエラーが発生したため処理できませんでした。'
							break
						case 'invalidUser':
							this.error.warning = '依頼できないユーザーです。'
							break
					}

					if (data.validationErrors) {
						Object.keys(this.error).forEach(key => {
							if (data.validationErrors[key]) {
								this.error[key] = data.validationErrors[key]
							}
						})
						if (data.validationErrors.has_work_forms) {
							this.error.works = data.validationErrors.has_work_forms
						}
					}

					this.fixScroll()
				})
		},
		buildPostData () {
			const postData = new URLSearchParams()
			postData.append('_VALIDPOST', this.postToken)
			Object.keys(this.value).forEach(key => {
				const value = this.value[key]
				if (!Array.isArray(value)) {
					postData.append(key, value)
				} else {
					value.forEach(el => {
						postData.append(`${key}[]`, el)
					})
				}
			})
			return postData
		},
		resetErrors () {
			Object.keys(this.error).forEach(key => {
				this.error[key] = null
			})
		},
		fixScroll () {
			/** @type {Element} */
			const scrollPoint = this.$refs.scrollPoint
			scrollPoint.scrollIntoView({ behavior: 'smooth' })
		},
		handleUpdateDate () {
			if (typeof this.loadCancel === 'function') {
				this.loadCancel()
			}
			this.possibleRequest = false

			const v = this.value
			if (!v.date || this.timeIsEmpty || !this.timeIsValid) {
				return
			}

			const url = `${this.appUrl}/maman/${this.mamanId}/availability.json`
			const postData = new URLSearchParams()
			postData.append('_VALIDPOST', this.postToken)
			postData.append('maman_id', this.mamanId)
			postData.append('date', v.date)
			postData.append('time_from', v.e_time_from)
			postData.append('time_to', v.e_time_to)

			axios.post(url, postData, {
				// 通信を中断するための関数を用意
				cancelToken: new axios.CancelToken(c => { this.loadCancel = c })
			})
				.then(response => {
					const { status } = response.data
					switch (status) {
						case Availability.available:
							this.error.e_time_to = null
							this.possibleRequest = false
							break
						case Availability.possible:
							this.error.e_time_to = null
							this.possibleRequest = true
							break
						case Availability.not:
							this.error.e_time_to = 'その時間帯は受付できません。スケジュールをご確認ください。'
							break
					}
				})
				.catch(error => {
					console.warn(error)
				})
		}
	},
	watch: {
		'value.date' () {
			this.error.date = null
			this.handleUpdateDate()
		},
		'value.e_time_from' () {
			this.error.e_time_from = null
			this.error.e_time_to = null
			this.handleUpdateDate()
		},
		'value.e_time_to' () {
			this.error.e_time_from = null
			this.error.e_time_to = null
			this.handleUpdateDate()
		},
		'value.works' () {
			this.error.works = null
		}
	},
	components: {
		TimeInput,
		FormError
	},
	template: `
		<div id="request-form">
			<div class="scroll-point" ref="scrollPoint"></div>

			<div class="alert alert-warning" v-if="error.warning">
				{{ error.warning }}
			</div>
			<div class="alert alert-danger" v-if="error.fatal">
				{{ error.fatal }}
			</div>
			<div class="alert alert-warning" v-if="error.userNotExist">
				ログイン状態が解除されました。<a :href="appUrl + '/user/login'">ログイン</a>してから再度お手続きください。
			</div>

			<dl class="lst-detail">
				<dt>依頼日時</dt>
				<dd>
					<div
						:class="{ 'is-invalid': error.date || error.e_time_from || error.e_time_to }"
					>
						<input
							type="date"
							class="form-control"
							v-model="value.date"
							min="2020-07-22"
							readonly="1"
							required=""
							data-error="正しい日付を入力してください"
						/>　<br class="sp">
						<TimeInput
							v-model="value.e_time_from"
						/>
						～
						<TimeInput
							v-model="value.e_time_to"
						/>
					</div>
					<div v-if="possibleRequest" class="alert alert-info">
						この時間帯はスケジュールに登録されていませんが依頼の相談はできます
					</div>
					<FormError v-if="!timeIsEmpty && !timeIsValid">
						2時間以上の期間を設定してください。
					</FormError>
					<template v-else>
						<FormError v-if="error.date">
							{{ error.date }}
						</FormError>
						<FormError v-if="error.e_time_from">
							{{ error.e_time_from }}
						</FormError>
						<FormError v-if="error.e_time_to">
							{{ error.e_time_to }}
						</FormError>
					</template>
				</dd>
				<dt>内容</dt>
				<dd>
					<div
						class="validation-group"
						:class="{ 'is-invalid': error.works }"
					>
						<div class="bs-form-inline">
							<div
								class="checkbox"
								v-for="work in works"
								:key="work.id"
							>
								<label>
									<input type="checkbox" v-model="value.works" :value="work.id">
									<span>{{ work.name }}</span>
								</label>
							</div>
						</div>
					</div>
					<FormError v-if="error.works">
						{{ error.works }}
					</FormError>
				</dd>
				<dt>メッセージ</dt>
				<dd>
					<textarea
						v-model="value.request"
						class="form-control"
						placeholder="ご要望やママンへのメッセージなどありましたらお書きください"
						rows="3"
					></textarea>
					<FormError v-if="error.request">
						{{ error.request }}
					</FormError>
				</dd>
			</dl>
			<div class="btn-client">
				<button
					type="button"
					@click="confirmSubmit"
				>
					依頼する
				</button>
			</div>
		</div>
	`
}
